// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.play {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 420px;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  overscroll-behavior: none;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}

.playArea {
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  flex-direction: row;
  justify-content: center;
  touch-action: none;
}

.playAreaColumn {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
  max-width: 500px;
}

.play__rarity-note {
  text-align: center;
  font-size: 0.74rem;
  color: var(--palette-text-muted);
  margin: 14px 0 calc(env(safe-area-inset-bottom, 0px) + 14px);
}

/* Compact the play screen on short, non-portrait viewports (e.g. a square or
   landscape desktop window). The board is a square sized to the available
   vertical space, so when height is scarce the tiles collapse and the fixed
   score/word/found reserved bands leave a large empty gap above the grid.
   Here we reclaim that reserved space so the board fills more of the frame.

   The \`min-aspect-ratio: 3 / 4\` guard is deliberate: portrait phones (the
   primary target) always have an aspect ratio well below 0.75 — even as
   Safari's URL bar shows/hides and changes \`dvh\` — so they NEVER match this
   query. That keeps the carefully tuned portrait/iOS layout untouched and
   avoids any dynamic-viewport layout shift. \`.play\`-scoped selectors keep
   these overrides winning regardless of stylesheet import order. */
@media (max-height: 760px) and (min-aspect-ratio: 3 / 4) {
  .play .wordInProgressContainer {
    flex-basis: 44px;
    height: 44px;
  }
  .play .play__found {
    flex-basis: 34px;
    height: 34px;
  }
  .play .play__scores {
    padding-top: 0;
    padding-bottom: 2px;
  }
  .play .play__scores .stat {
    padding-top: 3px;
    padding-bottom: 3px;
  }
  .play .buttonsBelowPuzzleContainer {
    margin-top: 8px;
  }
  .play .play__rarity-note {
    margin-top: 8px;
    margin-bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/puzzleScreen.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,4DAA4D;AAC9D;;AAEA;;;;;;;;;;;mEAWmE;AACnE;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,2DAA2D;EAC7D;AACF","sourcesContent":[".play {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  max-width: 420px;\n  height: 100vh;\n  height: 100dvh;\n  overflow: hidden;\n  overscroll-behavior: none;\n  touch-action: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.playArea {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  flex-direction: row;\n  justify-content: center;\n  touch-action: none;\n}\n\n.playAreaColumn {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  max-width: 500px;\n}\n\n.play__rarity-note {\n  text-align: center;\n  font-size: 0.74rem;\n  color: var(--palette-text-muted);\n  margin: 14px 0 calc(env(safe-area-inset-bottom, 0px) + 14px);\n}\n\n/* Compact the play screen on short, non-portrait viewports (e.g. a square or\n   landscape desktop window). The board is a square sized to the available\n   vertical space, so when height is scarce the tiles collapse and the fixed\n   score/word/found reserved bands leave a large empty gap above the grid.\n   Here we reclaim that reserved space so the board fills more of the frame.\n\n   The `min-aspect-ratio: 3 / 4` guard is deliberate: portrait phones (the\n   primary target) always have an aspect ratio well below 0.75 — even as\n   Safari's URL bar shows/hides and changes `dvh` — so they NEVER match this\n   query. That keeps the carefully tuned portrait/iOS layout untouched and\n   avoids any dynamic-viewport layout shift. `.play`-scoped selectors keep\n   these overrides winning regardless of stylesheet import order. */\n@media (max-height: 760px) and (min-aspect-ratio: 3 / 4) {\n  .play .wordInProgressContainer {\n    flex-basis: 44px;\n    height: 44px;\n  }\n  .play .play__found {\n    flex-basis: 34px;\n    height: 34px;\n  }\n  .play .play__scores {\n    padding-top: 0;\n    padding-bottom: 2px;\n  }\n  .play .play__scores .stat {\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n  .play .buttonsBelowPuzzleContainer {\n    margin-top: 8px;\n  }\n  .play .play__rarity-note {\n    margin-top: 8px;\n    margin-bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
